import React from 'react';
import CreditMemoAdmin from '../../CreditMemo/CreditMemoAdmin';
import CreditMemoRequestAdmin from '../../CreditMemo/CreditMemoRequestAdmin';
import TabbedPage from '../../../../Elements/TabbedPage';

export default class ClientInvoiceCreditMemosTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  tabs = [
    {
      label: 'Credit Memo',
      id: 'creditmemo',
      icon: 'fa-solid fa-credit-card',
      component: <CreditMemoAdmin clientInvoiceId={this.props.clientInvoiceId} />
    },
    {
      label: 'Credit Memo Request',
      id: 'creditmemorequest',
      icon: 'fa-solid fa-memo-circle-info',
      component: <CreditMemoRequestAdmin clientInvoiceId={this.props.clientInvoiceId} />
    }
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage tabs={this.tabs} removeSearchParametersOnTabChange={true} />
          </div>
        </div>
      </div>
    );
  }
}
